import { stripeBgColor } from './StripeStore';

import { stripeBgColorDefault } from './StripeStoreDefaults';

export const resetStripeBgColor = () => stripeBgColor.set(stripeBgColorDefault);
